import { useGlobalCtx } from "../../../Context/GlobalContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation, faCalendarXmark } from '@fortawesome/pro-regular-svg-icons';
import { Button } from "@progress/kendo-react-buttons";
import { SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_StudyType } from "../../../api";
import { useRef, useEffect } from "react";
import { ScheduleState, UserResponse } from "../../../Common";
import { useRecruitCtx, useRecruitDispatchCtx } from "../../../Context/RecruitContext";
import { useSurveyCtx } from "../../../Context/SurveyContext";

interface RecruitDeclineProps {
  studyName: string
  studyType: SurveyEngine_Models_StudyType
  getNextQuestionCommand: (surveySID: string, payLoad: UserResponse, isFirstTime?: boolean) => void
}



export const RecruitDecline = (props: RecruitDeclineProps) => {

  const globalCtx = useGlobalCtx();
  const recruitCtx = useRecruitCtx();
  const recruitCtxDispatch = useRecruitDispatchCtx()
  const buttonRef = useRef<Button>(null);
  const surveyCtx = useSurveyCtx();

  let declineLabels = "declineHeading declineMsg"

  useEffect(() => {

    buttonRef.current?.element?.focus();

  }, [recruitCtx])

  const onDeclineConfirm = () => {
    let recruitResponse: SurveyEngine_Models_RecruitResponse = {
      commandIndex: surveyCtx.NextQuestion.commandIndex,
      commandType: surveyCtx.NextQuestion.commandType,
      declined: true,
      eventUrl: "",
      inviteeUrl: "",
      sessionIds: []
    }
    props.getNextQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!, [recruitResponse]);
  }
  const onBack = () => {
    recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.SCHEDULE });
  }
  return (
    <div className="theme-session w-full">

      <div className="flex flex-col mb-4">
        <div id="declineHeading" className="theme-session-header w-full block">
          <FontAwesomeIcon  className="theme-session-header-icon" icon={faCalendarXmark} />
          <span className="theme-session-header-text ml-2 text-3xl font-regular">{globalCtx.LangResources.recruitMsg.decline.heading}</span>
        </div>
      </div>

      <div className="flex flex-col mb-4 md:min-h-52">
        <div className="mt-4">
          <div className="text-xl pb-6 font-semibold">{globalCtx.LangResources.recruitMsg.studyMsg.replace('{StudyName}', props.studyName)}</div>
          <div id="declineMsg">
            <span className="text-base font-semibold"><FontAwesomeIcon  className="theme-validator-error-icon theme-icon-spacer" icon={faCircleExclamation} /> {globalCtx.LangResources.recruitMsg.decline.message.replace('{StudyName}', props.studyName)}</span>
          </div>
        </div>
      </div>

      <div className={'theme-btn-container min-h-[5vh] md:flex justify-between pt-8 pb-2 mt-8'}>
      <div className="mb-8 md:basis-1 lg:basis-1/4">
          <div className="flex flex-col">
            <Button
              id="backButton"
              className="theme-btn-previous w-full"
              data-testid="back-button"
              onClick={onBack}
              aria-labelledby="backMsg backButton"
            >{globalCtx.LangResources.recruitMsg.backButton ?? "Back"}</Button>
            <div id="backMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.backButtonMsg}</div>
          </div>
        </div>
        
        <div className="md:basis-1 lg:basis-1/4">
          <div className="flex flex-col">
            <Button
              id="declineButton"
              ref={buttonRef}
              className="theme-btn-decline w-full"
              data-testid="decline-btn"
              onClick={onDeclineConfirm}
              aria-labelledby={`${declineLabels} declineButton`}
            >
              {globalCtx.LangResources.recruitMsg.declineButton}
            </Button>
            <div className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.declineButtonMsg}</div>
          </div>
        </div>

      </div>
    </div>
  )
}